export default "__VITE_ASSET__2128OtuB__"